<script setup>
import { computed, ref } from 'vue';

import NextButton from 'dashboard/components-next/button/Button.vue';
import MacroPreview from './MacroPreview.vue';
// DEBT: macro com prompts pergunta os valores ANTES de executar.
import MacroPromptDialog from './MacroPromptDialog.vue';
import { extractMacroPrompts } from './macroPromptHelper';

const props = defineProps({
  macro: {
    type: Object,
    required: true,
  },
  isExecuting: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['execute']);

const showPreview = ref(false);

// DEBT -- re-portado para a arquitetura de v4.17.0. Antes o proprio item executava a macro, e
// era ali que o dialogo de prompts entrava. Agora o item so EMITE e quem executa e List.vue
// (useMacroExecution), entao o dialogo continua aqui -- e este componente que conhece a macro --
// mas o resultado sai como payload do evento em vez de virar dispatch local.
const showPromptDialog = ref(false);
const macroPrompts = computed(() => extractMacroPrompts(props.macro));

const onPlayClick = () => {
  if (macroPrompts.value.length > 0) {
    showPromptDialog.value = true;
    return;
  }
  emit('execute', {});
};

const onPromptSubmit = prompts => {
  showPromptDialog.value = false;
  emit('execute', prompts);
};

// Nao fecha enquanto a execucao corre: o pai controla isExecuting, e fechar no meio deixaria
// o agente sem sinal do que esta acontecendo.
const onPromptCancel = () => {
  if (props.isExecuting) return;
  showPromptDialog.value = false;
};

const toggleMacroPreview = () => {
  showPreview.value = !showPreview.value;
};

const closeMacroPreview = () => {
  showPreview.value = false;
};
</script>

<template>
  <div
    class="relative flex items-center justify-between leading-4 rounded-md h-10 pl-3 pr-2"
    :class="showPreview ? 'cursor-default' : 'drag-handle cursor-grab'"
  >
    <span
      class="overflow-hidden whitespace-nowrap text-ellipsis font-medium text-n-slate-12"
    >
      {{ macro.name }}
    </span>
    <div class="flex items-center gap-1 justify-end">
      <NextButton
        v-tooltip.left-start="$t('MACROS.EXECUTE.PREVIEW')"
        icon="i-lucide-info"
        slate
        faded
        xs
        @click="toggleMacroPreview"
      />
      <NextButton
        v-tooltip.left-start="$t('MACROS.EXECUTE.BUTTON_TOOLTIP')"
        icon="i-lucide-play"
        slate
        faded
        xs
        :is-loading="isExecuting"
        :disabled="isExecuting"
        @click="onPlayClick"
      />
    </div>
    <transition name="menu-slide">
      <MacroPreview
        v-if="showPreview"
        v-on-clickaway="closeMacroPreview"
        :macro="macro"
      />
    </transition>
  </div>

    <transition name="menu-slide">
      <MacroPromptDialog
        v-if="showPromptDialog"
        :macro-name="macro.name"
        :prompts="macroPrompts"
        :is-executing="isExecuting"
        @submit="onPromptSubmit"
        @cancel="onPromptCancel"
      />
    </transition>
</template>
